import { Injectable } from '@angular/core'
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable } from 'rxjs'
import { finalize } from 'rxjs/operators'

import { SpinnerHandlerService } from '../services'

@Injectable({
  providedIn: 'root',
})
export class SpinnerInterceptorService implements HttpInterceptor {
  constructor(public spinnerHandler: SpinnerHandlerService) {}

  // intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
  //   let requestHandled = false
  //   setTimeout(() => {
  //     if (!requestHandled) {
  //       this.spinnerHandler.handleRequest('plus')
  //     }
  //   }, 100)
  //   // this.spinnerHandler.handleRequest('plus')
  //   const requestFinished = () => {
  //     requestHandled = true
  //     this.spinnerHandler.handleRequest()
  //   }
  //   return next.handle(request).pipe(finalize(requestFinished))
  // }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.spinnerHandler.handleRequest('plus')
    return next.handle(request).pipe(finalize(this.finalize.bind(this)))
  }

  finalize = (): void => this.spinnerHandler.handleRequest()
}
